import changeTheNumber from "./IncDec";
import {combineReducers } from "redux";

const rootReducer = combineReducers({
    changeTheNumber
})

export default rootReducer;